import React, { useEffect } from 'react';

import IMg1 from '../assets/img/aboutimg1.png';
import Img2 from '../assets/img/about/aboutimg.png';
import Img21 from '../assets/img/about/about_banner_mobile.png';
import Line from '../assets/img/about/line.png';
import Img3 from '../assets/img/aboutimg3.png';
import Img4 from '../assets/img/aboutslide.jpg';


import Icon1 from '../assets/img/about/icon1.png';
import Icon2 from '../assets/img/about/icon2.png';
import Icon3 from '../assets/img/about/icon3.png';
import Icon4 from '../assets/img/about/icon4.png';
import Icon11 from '../assets/img/about/icon11.png';
import Icon21 from '../assets/img/about/icon21.png';
import Icon31 from '../assets/img/about/icon31.png';
import Icon41 from '../assets/img/about/icon41.png';

import Start from '../assets/img/about/Star.png';

import feature1 from '../assets/img/feature1.png';
import feature2 from '../assets/img/feature2.png';



 import SeoHelmet from "../components/SeoHelmet";

const Aboutus = () => {

     useEffect(() => {
    document.body.classList.add('about-page');

    return () => {
      document.body.classList.remove('about-page');
    };
  }, []);

  return (
    <>
     <SeoHelmet />


        <section class="about">
            <div className='container'>
                <div className='mbrweb_row'>
                    <div className='mbr-col-sm-6'>
                        <img  src={Img2} className='about_img' />
                        <img src={Img21} className='about_img1' />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>
                            <img src={Line}></img>
                            <div>
                            <p>Not just a stylist. Not just a fashion consultant. Bhavana Singh is difficult to fit into a single title—because her work goes far beyond clothes or appearances.</p>
                            <p>Bhavana Singh is a <b>Personality & Image Transformation Coach</b> who works at the intersection of confidence, presence, and personal power. With over a decade of experience, Bhavana has transformed the lives of 1000+ individuals—helping them show up stronger, clearer, and more self-assured in every space they enter. A TEDx speaker, author of Chappals to Heels, pageant coach, and pageant judge, her work goes far beyond clothes. It’s about building a personality that commands respect, confidence, and attention—naturally.</p>
                            <p>Bhavana’s approach is deeply personal and intentional. Having grown up without the mentorship she once needed, her mission today is to become that guide for others—someone who helps unlock potential, remove self-doubt, and create unstoppable self-belief. Through image, mindset, and presence coaching, she helps individuals own who they are, elevate how they show up, and step into the best version of themselves. This is transformation that lasts—inside first, and then everywhere else.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="clients">
            <div class="container">
                <div className='numbox'>
                    <div className='bxcol'>
                        <img className='about_icon' src={Icon1} /><img className='about_icon1' src={Icon11} />
                        <div>
                            <p>1000+</p>
                            <span>Lives Transformed</span>
                        </div>
                    </div>
                    <div className='bxcol'>
                        <img className='about_icon' src={Icon2} /><img className='about_icon1' src={Icon21} />
                         <div>
                            <p>10+</p>
                            <span>Years of Experience</span>
                        </div>
                    </div>
                    <div className='bxcol'>
                        <img className='about_icon' src={Icon3} /><img className='about_icon1' src={Icon31} />
                         <div>
                            <p>5+</p>
                            <span>Pageants  Judged</span>
                        </div>
                    </div>
                    <div className='bxcol'>
                        <img className='about_icon' src={Icon4} /><img className='about_icon1' src={Icon41} />
                         <div>
                            <p>1</p>
                            <span>Brand Built</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="bio">
            <div className='container'>
                <p>“I envision a world where you conquer your fears, shatter limitations, and live a life of unparalleled success. You command respect, radiate confidence, and inspire others to reach for their own greatness. Always remember, you are a force to be reckoned with!”</p>
                <h2 className='about_bhavana'>— Bhavana Singh</h2>
            </div>
      
            <div class="breaking-news">
                <div class="breaking-news__marquee">
                    <div class="breaking-news__inner">
                        <span><a href="/personality-development-courses"><img src={Start}></img> <p>Join Transform with Bhavana Singh | 2 Weeks Intensive Program </p></a></span>
                        <span><a href="/personality-development-courses"><img src={Start}></img> <p>Join Transform with Bhavana Singh | 2 Weeks Intensive Program </p></a></span>
                    </div>
                </div>
            </div>
            
        </section>
         <div class="breaking-news_mobile">
                <div className='container'>
                    <h2>FEATURED PROGRAMS</h2>
                    <ul>
                        <li><img src={feature1}></img> 2 Weeks Business Intensive Program</li>
                        <li><img src={feature2}></img> 1 Week Personality Transformation</li>
                        <li><img src={feature1}></img> One-on-One Coaching Sessions</li>
                    </ul>
                </div>
         </div>
    </>
  );
}; 

export default Aboutus;
